/**
 * @file API service — a3Service.
 * A3 Service
 * All API calls related to A3 stage
 */

import axiosClient from "../api/axiosClient";
import { API_URLS } from "../constants/apiUrls";
import { FormDataResponse } from "../interfaces/formInterfaces";

/**
 * Get form data for A3 stage
 */
export const getA3FormData = async (
  stageCode: string,
  options?: { materialId?: number | string }
): Promise<{
  success: boolean;
  data: FormDataResponse | null;
  error?: string;
}> => {
  try {
    const params =
      options?.materialId != null && String(options.materialId).trim() !== ""
        ? { materialId: options.materialId }
        : undefined;
    const response = await axiosClient.get(API_URLS.FORMS_STAGE(stageCode), {
      params,
    });
    return {
      success: true,
      data: response.data.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.message || "Failed to fetch form data",
      data: null,
    };
  }
};

/**
 * Get submission by ID
 */
export const getSubmission = async (
  submissionId: string
): Promise<{
  success: boolean;
  data: any | null;
  error?: string;
}> => {
  try {
    const response = await axiosClient.get(API_URLS.SUBMISSIONS.BY_ID(submissionId));
    return {
      success: true,
      data: response.data.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.message || "Failed to fetch submission",
      data: null,
    };
  }
};

/**
 * Save A3 stage data
 */
export const saveA3Details = async (
  submissionId: string,
  payload: any
): Promise<{
  success: boolean;
  message?: string;
  error?: string;
}> => {
  try {
    const response = await axiosClient.put(
      API_URLS.SUBMISSIONS.A3(submissionId),
      payload
    );
    return {
      success: true,
      message: response.data?.message || "A3 data saved successfully",
    };
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to save A3 data";
    return {
      success: false,
      error: errorMessage,
    };
  }
};

